function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import get from 'lodash.get';
import cloneDeep from 'lodash.clonedeep';
import { createSubscription } from './utils/subscription';
import { createTargetWatcher } from './utils/watcher';
export function simplyReactive(entities, options) {
  var data = get(entities, 'data', {});
  var watch = get(entities, 'watch', {});
  var methods = get(entities, 'methods', {});
  var onChange = get(options, 'onChange', function () {});

  var _createSubscription = createSubscription(),
      subscribe = _createSubscription.subscribe,
      notify = _createSubscription.notify,
      subscribers = _createSubscription.subscribers;

  var _createTargetWatcher = createTargetWatcher(),
      targetWatcher = _createTargetWatcher.targetWatcher,
      getTarget = _createTargetWatcher.getTarget;

  var _data;

  var _methods = {};

  var getContext = function getContext() {
    return {
      data: _data,
      methods: _methods
    };
  };

  var callingMethod = false;

  var methodWithFlags = function methodWithFlags(fn) {
    return function () {
      callingMethod = true;
      var result = fn.apply(void 0, arguments);
      callingMethod = false;
      return result;
    };
  }; // init methods before data, as methods may be used in data


  Object.entries(methods).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        methodName = _ref2[0],
        methodItem = _ref2[1];

    _methods[methodName] = methodWithFlags(function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return methodItem.apply(void 0, [getContext()].concat(args));
    });
    Object.defineProperty(_methods[methodName], 'name', {
      value: methodName
    });
  });
  _data = new Proxy(cloneDeep(data), {
    get: function get(target, prop) {
      if (getTarget() && !callingMethod) {
        subscribe(getTarget(), {
          prop: prop,
          value: target[prop]
        });
      }

      return Reflect.get.apply(Reflect, arguments);
    },
    set: function set(target, prop, value) {
      // if value is the same, do nothing
      if (target[prop] === value) {
        return true;
      }

      Reflect.set.apply(Reflect, arguments);

      if (!getTarget()) {
        onChange && onChange(prop, value);
        notify(_data, prop);
      }

      return true;
    }
  });
  Object.entries(watch).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        watchName = _ref4[0],
        watchItem = _ref4[1];

    targetWatcher(watchName, function () {
      watchItem(getContext());
    });
  });
  var output = [_data, _methods];
  output._internal = {
    _getSubscribers: function _getSubscribers() {
      return subscribers;
    }
  };
  return output;
}